module.exports = __webpack_public_path__ + "8f062c892d477b40adc819fab094afb2.svg";